import { render, staticRenderFns } from "./MailpoetSettings.vue?vue&type=template&id=25d38052"
import script from "./MailpoetSettings.vue?vue&type=script&lang=js"
export * from "./MailpoetSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports